import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import readConfig from './utils/readClientConfiguration';
import appConfiguration from './config/default.json';

// Pobierz kod kraju z konfiguracji
let countryCode = readConfig(appConfiguration, 'countrySymbol') || 'hr';

// Funkcja do dynamicznego ładowania tłumaczeń
const loadTranslations = async (language) => {
    try {
        const translations = await import(`./locales/${language}/translations.json`);
        return translations.default;
    } catch (error) {
        console.error(`Failed to load translations for ${language}:`, error);
        // Fallback do HR jeśli brakuje tłumaczeń
        if (language !== 'hr') {
            const fallback = await import(`./locales/hr/translations.json`);
            return fallback.default;
        }
        return {};
    }
};

// Preload tylko potrzebny język dla hydratacji
const initI18n = async () => {
    const currentLanguageTranslations = await loadTranslations(countryCode);
    
    return i18n
        .use(resourcesToBackend((language, namespace) => {
            return loadTranslations(language);
        }))
        .use(initReactI18next)
        .init({
            lng: countryCode,
            fallbackLng: 'hr',
            debug: process.env.NODE_ENV === 'development',
            interpolation: {
                escapeValue: false,
            },
            ns: ['translations'],
            defaultNS: 'translations',
            resources: {
                [countryCode]: {
                    translations: currentLanguageTranslations
                }
            },
            react: {
                useSuspense: false
            }
        });
};

// Initialize i18n synchronously for SSR compatibility
const initI18nSync = () => {
    // Preload all translations synchronously for SSR
    let hrTranslations = {};
    let rsTranslations = {};
    let siTranslations = {};
    
    try {
        hrTranslations = require('./locales/hr/translations.json');
        rsTranslations = require('./locales/rs/translations.json');
        siTranslations = require('./locales/si/translations.json');
    } catch (error) {
        console.error('Failed to load translations:', error);
    }

    return i18n
        .use(initReactI18next)
        .init({
            lng: countryCode,
            fallbackLng: 'hr',
            debug: process.env.NODE_ENV === 'development',
            interpolation: {
                escapeValue: false,
            },
            ns: ['translations'],
            defaultNS: 'translations',
            resources: {
                'hr': {
                    translations: hrTranslations
                },
                'rs': {
                    translations: rsTranslations
                },
                'si': {
                    translations: siTranslations
                }
            },
            react: {
                useSuspense: false
            }
        });
};

// Initialize i18n synchronously for SSR compatibility
initI18nSync();

export default i18n;